import React, { Component } from 'react';
import Select from 'react-select';
import withRouter from "../../Utils/withRouter";
import axios from "axios";
import { formatDate, } from "../../Components/InputElements";
import Swal from "sweetalert2";
import { ConfigContext } from "../../Context/ConfigContext";
import { currentDateAndTime, decodeData, genderOptions, emergencyContactPerson } from '../../Constants/constants';


class FamilyDetails extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_degree: '',
      institute_university: '',
      year_of_passout: '',
      percentage_grade: '',
      employee_qualification_document: '',
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      keyword: "",
      from_date: "",
      to_date: "",
      employee_family_id:'',
      family_member_name: '',
      family_member_relation: '',
      family_member_dob:'',
      family_member_gender:'Male',
      family_member_contact_number:'',
      family_member_dependent:'0',
      relation: 'No',
      emergency_Contact_Person: 'Brother',
      is_Dependend: 'No',
      date_Of_Birth: '',
      // gender: 'Male',
      mobile_Number: '',
      errors: {},
      decodedData: [],
    };
    this.closeRef = React.createRef();
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const errors = this.validateForm();

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const employee_id = this.props.params.employee_id;
    var formData = {
      // this.state.employee_qualification_id &&  formData.append('employee_qualification_id', this.state.employee_qualification_id);
      employee_id: employee_id,
      employee_family_id: this.state.employee_family_id ,
      family_member_name: this.state.family_member_name,
      family_member_relation: this.state.family_member_relation,
      family_member_dependent: this.state.family_member_dependent,
      family_member_dob: this.state.family_member_dob,
      family_member_gender: this.state.family_member_gender,
      family_member_contact_number: this.state.family_member_contact_number,
      date: currentDateAndTime()

    }
    // this.state.employee_family_id &&  formData.append('employee_family_id', this.state.employee_family_id);
    axios.post(`${apiURL}Employees/CreateEmployeeFamily`, formData, { headers }).then((response) => {
      const { success } = response.data;
      if (success === true) {
        this.setState({
          // employee_family_id:'',
          family_member_name: '',
          family_member_relation:'',
          family_member_dob:'',
          family_member_gender:'Male',
          family_member_contact_number:'',
          family_member_dependent:'0',
          // relation: 'No',
          // emergency_Contact_Person: 'Brother',
          // is_Dependend: 'No',
          // date_Of_Birth: '',
          // gender: 'Male',
          // mobile_Number: '',
        });
        this.closeRef.current.click();
        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick:false
        })
      } else {
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          timer: 2000,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
      }

    })
  };
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Employees/GetEmployeeFamilies`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          employee_id: this.props.params.employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
            employee_family_id:'',
            family_member_name: '',
            family_member_relation: '',
            family_member_dob:'',
            family_member_gender:'',
            family_member_contact_number:'',
            family_member_dependent:'',
            errors:{}
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };
  GetInfo = (row) => {
    this.setState(
        {
          employee_family_id: row.employee_family_id,
          
          family_member_name: row?.family_member_name,
          family_member_relation: row?.family_member_relation,
          family_member_dob: row?.family_member_dob,
          family_member_gender: row?.family_member_gender,
          family_member_contact_number: row?.family_member_contact_number,
          family_member_dependent: row?.family_member_dependent,
          
        
                errors:{}
            
        }
    )
}
  // handleRadioChange = (name, value) => {
  //   this.setState((prevState) => ({
  //     [name]: value,
  //     errors: {
  //       ...prevState.errors,
  //       [name]: '',
  //     },
  //   }));
  // };
  handleRadioChange = (name, value) => {
    if (name === "family_member_dependent" && value === "0") {
        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    }
    else {
        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    }


};
handleEdit= (row)=>{
  console.log("row==>",row)
  this.setState({
    employee_family_id: row.employee_family_id,
    family_member_name: row?.family_member_name,
    family_member_relation: row?.family_member_relation,
    family_member_dob: row?.family_member_dob,
    family_member_gender: row?.family_member_gender,
    family_member_contact_number: row?.family_member_contact_number,
    family_member_dependent: row.family_member_dependent
    
  })
}
  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          // employee_family_id: this.props.params.employee_family_id,
          employee_family_id:id,
          employee_id: this.props.params.employee_id,
          date: currentDateAndTime(),

        };
        axios
          .post(`${apiURL}Employees/DeleteEmployeeFamily`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.success === true ? "Success" : "Failed"
                }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: true }, (prevState) => {
                this.GetList();
              });
            }
          })
          .catch((error) => {
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
            });
          });
      }
    });
  };
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  handleSelectChange = (name, selectedOption) => {
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList(); // This will log the updated state value
      }
    );
  };
  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList(); // This will log the updated state value
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList(); // This will log the updated state value
        }
      );
    }
  };
  validateForm = () => {
    const errors = {};
    const mobileRegex = /^[0-9]{10}$/;

    if (!this.state.family_member_name) errors.family_member_name = 'Family  Member Name is required';
    if (!this.state.family_member_contact_number) errors.family_member_contact_number = 'Relation is required';
    if (!this.state.family_member_dependent) errors.family_member_dependent = 'Dependend Field is required';
    if (!this.state.family_member_dob) errors.family_member_dob = 'Date Of Birth is required';
    if (!this.state.family_member_gender) errors.family_member_gender = 'Family Member Gender is required';
    if(!this.state.family_member_relation) errors.family_member_relation = 'Family Member Relation is required';
    if (!this.state.family_member_contact_number) errors.family_member_contact_number = 'Family Member Mobile number is required';
    if (this.state.family_member_contact_number && !mobileRegex.test(this.state.family_member_contact_number)) errors.family_member_contact_number = 'Family Member Mobile number is Invailid';
    return errors;
  };

  render() {
    const { errors } = this.state;


    return (
      <div>
        <div className='d-flex justify-content-between align-items-center'>
          <div>
            <h5>Family Details</h5>
          </div>
          <div>
            <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#FamilyDetails" onClick={()=>this.GetList()}>
              <i className="ri-menu-add-fill" style={{ fontSize: "16px" }} />
            </button>
            <div className="modal fade" id="FamilyDetails" tabIndex={-1} aria-labelledby="exampleModalgridLabel" aria-modal="true">
              <div className="modal-dialog modal-xl">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalgridLabel">Family Details</h5>
                    <button type="button" className="btn-close" ref={this.closeRef} data-bs-dismiss="modal" aria-label="Close" />
                  </div>
                  <div className="modal-body">
                    <div className="container mt-2">
                      <form onSubmit={this.handleSubmit}>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="family_member_name" className="form-label">Family Member Name:</label>
                            <input
                              type="text"
                              id="family_member_name"
                              name="family_member_name"
                              value={this.state.family_member_name}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.family_member_name ? 'is-invalid' : ''}`}
                              placeholder="Enter Family Member Name"
                            />
                            {errors.family_member_name && <div className="invalid-feedback">{errors.family_member_name}</div>}
                          </div>

                          <div className="col-md-6 mb-3">
                            <div>
                              <label htmlFor="relation" className="form-label">Relation:</label>
                            </div>
                            <Select
                              id="family_member_relation"
                              name="family_member_relation"
                              className={`${errors.family_member_relation ? 'is-invalid' : ''}`}
                              value={emergencyContactPerson.find(option => option.value === this.state.family_member_relation)}
                              onChange={(selectedOption) => this.handleSelectChange('family_member_relation', selectedOption)}
                              options={emergencyContactPerson}
                              placeholder="Select Relation"
                            />
                            {errors.family_member_relation && <div className="text-danger">{errors.family_member_relation}</div>}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="dateOfBirth" className="form-label">Date Of Birth:</label>
                            <input
                              type="date"
                              id="family_member_dob"
                              name="family_member_dob"
                              value={this.state.family_member_dob}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.family_member_dob ? 'is-invalid' : ''}`}
                              placeholder="Enter Date Of Birth"
                            />
                            {errors.family_member_dob && <div className="invalid-feedback">{errors.family_member_dob}</div>}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="family_member_gender" className="form-label"> Gender:</label>
                            <Select
                              id="family_member_gender"
                              name="family_member_gender"
                              value={genderOptions.find(option => option.value === this.state.family_member_gender)}
                              onChange={(selectedOption) => this.handleSelectChange('family_member_gender', selectedOption)}
                              options={genderOptions}
                              placeholder="Select your Gender"
                            />
                            {errors.family_member_gender && <div className="text-danger">{errors.family_member_gender}</div>}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="family_member_contact_number" className="form-label">Mobile Number:</label>
                            <input
                              type="number"
                              id="family_member_contact_number"
                              name="family_member_contact_number"
                              value={this.state.family_member_contact_number}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.family_member_contact_number ? 'is-invalid' : ''}`}
                              placeholder="Enter Mobile Number"
                            />
                            {errors.family_member_contact_number && <div className="invalid-feedback">{errors.family_member_contact_number}</div>}
                          </div>
                          {/* <div className="col-md-6 mb-3">
                          <div>
                            <label htmlFor="family_member_dependent" className="form-label">Dependent:</label>
                          </div>

                        
                          <div className="form-check form-check-inline">
                            <input
                              type="radio"
                              id="dependentYes"
                              name="family_member_dependent"
                              value="Yes"
                              checked={this.state.family_member_dependent === 'Yes'}
                              onChange={(e) => this.handleRadioChange(e)}
                              className={`form-check-input ${errors.family_member_dependent ? 'is-invalid' : ''}`}
                            />
                            <label htmlFor="dependentYes" className="form-check-label">Yes</label>
                          </div>

                          
                          <div className="form-check form-check-inline">
                            <input
                              type="radio"
                              id="dependentNo"
                              name="family_member_dependent"
                              value="No"
                              checked={this.state.family_member_dependent === 'No'}
                              onChange={(e) => this.handleRadioChange(e)}
                              className={`form-check-input ${errors.family_member_dependent ? 'is-invalid' : ''}`}
                            />
                            <label htmlFor="dependentNo" className="form-check-label">No</label>
                          </div>

                         
                          {errors.family_member_dependent && (
                            <div className="text-danger">{errors.family_member_dependent}</div>
                          )}
                        </div> */}

                                       <div class="col-md-6 mt-3 settings-section">
                                                        <div>
                                                            <label class="form-label">Dependent: 
                                                            <span className="ms-1">
                                                            
                                                            </span>  
                                                            </label>
                                                        </div>
                                                        <div class="form-check form-check-inline mt-2 mx-4">
                                                            <input
                                                                type="radio"
                                                                id="dependent_yes"
                                                                name="dependent_yes"
                                                                value='1'
                                                                checked={this.state.family_member_dependent == '1'}
                                                                onChange={() => this.handleRadioChange('family_member_dependent', '1')}
                                                                class="form-check-input"
                                                            // disabled={!this.state.employee_document_type_id}
                                                            />
                                                            <label htmlFor="dependent_yes" class="form-check-label">Yes</label>
                                                        </div>
                                                        <div class="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="dependent_no"
                                                                name="dependent_no"
                                                                value="0"
                                                                checked={this.state.family_member_dependent == '0'}
                                                                onChange={() => this.handleRadioChange('family_member_dependent', '0')}
                                                                class="form-check-input"
                                                            // disabled={!this.state.employee_document_type_id}
                                                            />
                                                            <label htmlFor="dependent_no" class="form-check-label">No</label>
                                                        </div>
                                                        </div>

                                          </div>
                                          <div className="d-flex justify-content-end">
                          {!this.state.loadingSubmit?
                            <button type="submit" className={`btn btn-${this.state.employee_family_id? "primary":"success"} btn-label waves-effect right waves-light`}>
                              <i className="bx bx-save label-icon align-middle fs-16 ms-2" /> {this.state.employee_family_id? "Update" :"Save"} </button>:
                              <button className={`btn btn-${this.state.employee_family_id? "primary":"success"} btn-load`}>
                            <span className="d-flex align-items-center">
                                <span className="spinner-border flex-shrink-0" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </span>
                                <span className="flex-grow-1 ms-2">
                                    {this.state.employee_family_id? "Updating..." :"Saving..."}
                                </span>
                            </span>
                          </button>
                          }
                          </div>
                                          
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <table className={`table table-bordered table-stripped`}>
            <thead className="table-light">
              <tr>
                <th>Member Name</th>
                <th>Relation</th>
                <th>Date Of Birth</th>
                <th>Gender</th>
                <th>Mobile Number</th>
                <th>Dependent</th>
                <th className="text-center">Action</th>

              </tr>
            </thead>
            <tbody>
              {this.state.rows.map((row) => {
                return (
                  <tr key={row.employee_family_id}>
                    <td>{row.family_member_name}</td>
                    <td>{row.family_member_relation}</td>
                    <td>{formatDate(row.family_member_dob)}</td>
                    <td>{row.family_member_gender}</td>
                    <td>{row.family_member_contact_number}</td>
                    <td>{row.family_member_dependent == 0 ? 'No' : 'Yes'}</td>
                    <td className="d-flex justify-content-around">
                    <button  onClick={() =>this.handleEdit(row)}
                              data-bs-toggle="modal" data-bs-target="#FamilyDetails"
                                className="btn-icon btn btn-sm btn-outline-primary">
                                <i className="ri-edit-box-line"></i>
                          </button>
                            {/* <button type='button' onClick={() => this.setState({() =>this.handleEdit(row)}, row.employee_family_id  (prevState) => this.GetInfo(row))} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button> */}
                      <button
                        onClick={() =>
                          this.handleDelete(row.employee_family_id)
                        }
                        className="btn-icon btn btn-sm btn-outline-danger"
                      >
                        {" "}
                        <i className="ri-delete-bin-line"></i>{" "}
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot className="table-light">
              <tr>
                <th colSpan={7}>
                  <div className="d-flex justify-content-between">
                    <button
                      disabled={this.state.prev === false && this.state.loadingList === false ? true : false}
                      type="button"
                      onClick={() => this.handlePrev()}
                      className={`btn btn-warning btn-label waves-effect waves-light`}
                    >
                      <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                      Previous
                    </button>
                    <div
                      className="col-md-4"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      {
                        <small>
                          Total Records: {this.state.total_records} |
                          Total Pages: {this.state.total_pages} |
                          Current Page: {this.state.page}
                        </small>
                      }
                    </div>
                    <div className="col-md-2">
                      <select
                        className="form-select"
                        onChange={(e) => this.handleChange(e)}
                      >
                        {Array.from(
                          { length: this.state.total_pages },
                          (_, i) => (
                            <option
                              selected={this.state.page === i + 1}
                              key={i}
                              value={i + 1}
                            >
                              Page {i + 1}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                    <button
                      disabled={
                        this.state.next === false &&
                          this.state.loadingList === false
                          ? true
                          : false
                      }
                      type="button"
                      onClick={() => this.handleNext()}
                      className={`btn btn-primary btn-label waves-effect right waves-light`}
                    >
                      <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />{" "}
                      Next
                    </button>
                  </div>
                </th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

    );
  }
}

export default withRouter(FamilyDetails);
